// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh2[data-v-b4ee30bc] {\n  color: var(--color-nickel);\n}\n.box[data-v-b4ee30bc] {\n  border-radius: 10px;\n}\na.is-secondary[data-v-b4ee30bc]{\n  background-color: var(--secondary);\n  color: #FFF !important;\n  font-weight: 600;\n  border-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
